export default {
  async getMatchingAddresses(
    addressString: string,
  ): Promise<Array<Record<string, any>>> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${process.env.VUE_APP_PROXY_URL}/v1/autocomplete`, true);
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.response));
        } else {
          reject(new Error(`Could not retrieve addresses ${xhr.status} ${xhr.statusText}`));
        }
      };
      const data = {
        addressString,
        placeTypes: ['streets', 'addresses'],
      };
      try {
        xhr.send(JSON.stringify(data));
      } catch (exception) {
        reject(exception);
      }
    });
  },
};
